import { BillsInterfaceState, initialBillsState } from '../state/bills.state';
import { BillsActions, EBillsActions } from '../actions/bills.actions';

export function billsReducer(state: BillsInterfaceState = initialBillsState, action: BillsActions): BillsInterfaceState {
  switch (action.type) {
    case EBillsActions.GetBillsSuccess: {
      return { ...state, bills: action.payload.data };
    }

    default:
      return state;
  }
};
